/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {calculateRecipients} from '../api'

export const useMutationCalculateRecipients = createReactQueryMutationHook('calculateRecipients', calculateRecipients)
